import React from "react";
import PropTypes from "prop-types";
import "./Loader.css";

const Loader = ({ size = "md" }) => {
  const sizeClass =
    {
      sm: "loader-sm",
      md: "loader-md",
      lg: "loader-lg",
    }[size] || "loader-md";

  return (
    <div className={`loader-container ${size === "sm" ? "inline" : ""}`}>
      <div className={`loader ${sizeClass}`}></div>
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default Loader;
